import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getDteRecibidos } from '../../helpers/api_helper';

const DteRecibidosHooks = () => {
    const [dtes, setDtes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);

    const empresa = useSelector((state) => state.Context.empresa);
    const empresas = useSelector((state) => state.LegacyEmpresas.legacyEmpresas)

    const fetchDtes = async (fechaDesde, fechaHasta, tipoDTE) => {
        let empresaSeleccionada;
        if (Array.isArray(empresas))
            empresaSeleccionada = empresas.find((e) => e.CLAEMP == empresa)

        if (!empresaSeleccionada) {
            setError('Empresa no seleccionada o rut no disponible');
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const params = {
                tenantId,
                rut: empresaSeleccionada.RUTEMP,
                fechaDesde,
                fechaHasta,
                tipoDTE
            };
            const response = await getDteRecibidos(params);
            if (Array.isArray(response)) {
                setDtes(response);
            } else {
                throw new Error('API returned invalid data format: expected an array');
            }
        } catch (err) {
            setError(`Failed to fetch DTEs: ${err.message || 'Unknown error'}`);
            setDtes([]);
        } finally {
            setLoading(false);
        }
    };

    return { dtes, loading, error, fetchDtes };
};

export default DteRecibidosHooks;